import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "t2-main" }
const _hoisted_2 = { class: "t2-content" }
const _hoisted_3 = { class: "container mar_b" }
const _hoisted_4 = { class: "tab_content" }
const _hoisted_5 = { class: "tab_cont" }
const _hoisted_6 = { class: "t6_table_c2" }

import Banner from "@/views/online-report/banner/index1.vue";
import {onBeforeMount, reactive} from "vue";
import {useRoute, useRouter} from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'projectInfo',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const item = reactive({
    projectcode: '',
    projectname: '',
    incJgmc: '',
    placeCode: '',
    jbrMc: '',
    jbrYddh: '',
    industry: '',
    scaleContent: '',
    projectNature: '',
    totalMoney: '',
});
onBeforeMount(()=>{
    let data = JSON.parse(JSON.stringify(history.state.obj))
    console.log("obj:", JSON.parse(data)?.projectcode)
    item.projectcode = JSON.parse(data)?.projectcode
    item.projectname = JSON.parse(data)?.projectname
    item.incJgmc = JSON.parse(data)?.incJgmc
    item.placeCode = JSON.parse(data)?.placeCode
    item.jbrMc = JSON.parse(data)?.jbrMc
    item.jbrYddh = JSON.parse(data)?.jbrYddh
    item.industry = JSON.parse(data)?.industry
    item.scaleContent = JSON.parse(data)?.scaleContent
    item.projectNature = JSON.parse(data)?.projectNature
    item.totalMoney = JSON.parse(data)?.totalMoney

    console.log("item:", item.projectcode)
});

return (_ctx: any,_cache: any) => {
  const _component_Top = _resolveComponent("Top")!
  const _component_Bottom = _resolveComponent("Bottom")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Top),
    _createVNode(Banner),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "t6_breadCream" }, [
            _createElementVNode("span", null, "首页"),
            _createTextVNode(),
            _createElementVNode("i", null, ">"),
            _createTextVNode(),
            _createElementVNode("span", null, "项目基本信息")
          ], -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("table", _hoisted_6, [
                _createElementVNode("tr", null, [
                  _cache[0] || (_cache[0] = _createElementVNode("th", null, "项目编码", -1)),
                  _createElementVNode("td", null, _toDisplayString(item.projectcode), 1),
                  _cache[1] || (_cache[1] = _createElementVNode("th", null, "项目名称", -1)),
                  _createElementVNode("td", null, _toDisplayString(item.projectname), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[2] || (_cache[2] = _createElementVNode("th", null, "申请单位名称", -1)),
                  _createElementVNode("td", null, _toDisplayString(item.incJgmc), 1),
                  _cache[3] || (_cache[3] = _createElementVNode("th", null, "项目建设地点", -1)),
                  _createElementVNode("td", null, _toDisplayString(item.placeCode), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[4] || (_cache[4] = _createElementVNode("th", null, "联系人名称", -1)),
                  _createElementVNode("td", null, _toDisplayString(item.jbrMc), 1),
                  _cache[5] || (_cache[5] = _createElementVNode("th", null, "联系人手机电话", -1)),
                  _createElementVNode("td", null, _toDisplayString(item.jbrYddh), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[6] || (_cache[6] = _createElementVNode("th", null, "项目所属行业", -1)),
                  _createElementVNode("td", null, _toDisplayString(item.industry), 1),
                  _cache[7] || (_cache[7] = _createElementVNode("th", null, "建设规模及内容", -1)),
                  _createElementVNode("td", null, _toDisplayString(item.scaleContent), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[8] || (_cache[8] = _createElementVNode("th", null, "项目建设性质", -1)),
                  _createElementVNode("td", null, _toDisplayString(item.projectNature), 1),
                  _cache[9] || (_cache[9] = _createElementVNode("th", null, "项目总投资(万元)", -1)),
                  _createElementVNode("td", null, _toDisplayString(item.totalMoney), 1)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Bottom)
  ], 64))
}
}

})